<template>
    <v-card>
        <v-card-title>
            Parcelamento de Fatura
        </v-card-title>
        <v-card-text>
            <v-data-table :headers="headers" :items="items">
                <template #[`item.bill`]="{ item }">
                    <a @click="$router.push(item.billRoute)">
                        {{ item.bill }}
                    </a>
                </template>
            </v-data-table>
            <!-- <v-simple-table>
                <thead>
                    <tr>
                        <th>
                            Fatura
                        </th>
                        <th>
                            Parcela
                        </th>
                        <th>
                            Vencimento
                        </th>
                        <th>
                            Pago Em
                        </th>
                        <th>
                            Valor
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="installment in billNegotiation.billInstallments"
                        :key="installment.installment"
                    >
                        <td></td>
                    </tr>
                </tbody>
            </v-simple-table> -->
        </v-card-text>
    </v-card>
</template>

<script>
import BillNegotiation from '@/models/BillNegotiation'

export default {
    props: {
        billNegotiation: {
            type: Object,
            required: true,
            validator: model => {
                return model instanceof BillNegotiation
            },
        },
    },

    data: () => {
        return {
            headers: [
                {
                    text: 'Fatura',
                    value: 'bill',
                },
                {
                    text: 'Parcela',
                    value: 'installment',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Vencimento',
                    value: 'dueAt',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Pago Em',
                    value: 'paidAt',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Valor',
                    value: 'amount',
                    align: 'center',
                    sortable: false,
                },
            ],
        }
    },

    computed: {
        items() {
            const items = []

            this.billNegotiation.billInstallments.forEach(installment => {
                items.push({
                    bill: `Fatura ${installment.bill.reference}`,
                    billRoute: {
                        name: 'bill.show',
                        params: { id: installment.bill_id },
                    },
                    installment: `${installment.installment}/${this.billNegotiation.installments}`,
                    dueAt: installment.bill.formattedDueAt,
                    paidAt: installment.bill.formattedPaidAt || '-',
                    amount: installment.formattedValue,
                })
            })

            return items
        },
    },
}
</script>

<style></style>
